export const HIDE_STRIPE_PLANS_FROM = [
  'partner_test',
  'affiliate',
  'staff',
  'staff_business',
  'shopify_alumni',
]

export const HIDE_STRIPE_PLANS_FROM_EMAILS = [
  '@shopify.com',
  '+test@one.store',
]

export const SHOW_FREE_PLAN = [
  'plus_partner_sandbox',
  'partner_test',
  'affiliate',
  'staff',
  'staff_business',
]
